import React from "react";
import SEO from "../../SEO";
import { useCanonicalUrl } from "../../useCanonicalUrl";

const Careers = () => {
  const canonical = useCanonicalUrl();
  return (
    <>
      <SEO
        title="Careers at Trust Doc"
        description="Explore job opportunities at Trust Doc."
        canonical={canonical}
      />

      <div className="careers-page">
        {/* Header Section */}
        <header className="careers-header">
          <h1>Careers at TrustDoc</h1>
          <p>
            Join our growing team of healthcare innovators! We’re always looking
            for passionate individuals who want to make a difference.
          </p>
        </header>

        {/* Careers Content Card */}
        <section className="careers-card">
          <h2>Current Openings</h2>
          <ul className="careers-list">
            <li>Software Developers</li>
            <li>Marketing Specialists</li>
            <li>Healthcare Coordinators</li>
            <li>Customer Support Executives</li>
          </ul>

          <div className="careers-footer">
            <p>
              Send your resume to:{" "}
              <a href="mailto:careers@trust-doc.com" className="careers-email">
                careers@trust-doc.com
              </a>
            </p>
          </div>
        </section>

        {/* Styles */}
        <style>{`
        .careers-page {
          min-height: 100vh;
          background: linear-gradient(to bottom right, #f0f9ff, #ffffff, #e0f2fe);
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 4rem;
        }

        .careers-header {
          width: 100%;
          background-color: #0369a1;
          color: white;
          text-align: center;
          padding: 1rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .careers-header h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
        }

        .careers-header p {
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.1rem;
          font-weight: 300;
          opacity: 0.9;
        }

        .careers-card {
          max-width: 800px;
          width: 100%;
          background: white;
          margin-top: 3rem;
          padding: 2.5rem 3rem;
          border-radius: 1.2rem;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          border: 1px solid #f3f4f6;
        }

        .careers-card h2 {
          font-size: 1.6rem;
          color: #0369a1;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }

        .careers-list {
          list-style: none;
          padding: 0;
          margin: 0 0 1.5rem;
        }

        .careers-list li {
          background-color: #f0f9ff;
          border-left: 4px solid #0369a1;
          padding: 0.75rem 1rem;
          margin-bottom: 0.8rem;
          border-radius: 0.5rem;
          color: #374151;
          font-size: 1.05rem;
          transition: background-color 0.2s;
        }

        .careers-list li:hover {
          background-color: #e0f2fe;
        }

        .careers-footer {
          margin-top: 1rem;
          font-size: 1.05rem;
          color: #374151;
        }

        .careers-email {
          color: #0369a1;
          font-weight: 500;
          text-decoration: none;
        }

        .careers-email:hover {
          text-decoration: underline;
        }

        @media (max-width: 600px) {
          .careers-card {
            padding: 2rem;
          }

          .careers-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
      </div>
    </>
  );
};

export default Careers;
